import React, { FC, useEffect } from 'react';
import Modal from '@fenderdigital/ui/Modal';
import BodyText from '@fenderdigital/ui/BodyText';
import Spacer from '@fenderdigital/ui/Spacer';
import { ButtonLink } from '@fenderdigital/ui/ButtonV2';
import Flex from '@fenderdigital/ui/Flex';
import usePlayUser from '@fenderdigital/custom-hooks/hooks/usePlayUser';
import { EventNames, trackEvent } from '../../lib/analytics';
import * as S from './ToolTipModal-styled';

interface TooltipModalProps {
  headline: string;
  bodyText: string;
  className?: string;
  ctaButtonTitle: string;
  ctaAction: () => void;
  ctaActionLink: string;
  target?: string;
}

const ToolTipModal: FC<TooltipModalProps> = ({
  headline,
  bodyText,
  className,
  ctaButtonTitle,
  ctaAction,
  ctaActionLink,
  target = '_self',
}) => {
  const { user } = usePlayUser();
  const toolTipModalButton = '[data-id="tooltip-modal-button"]';

  const trackingProperties = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    fc_id: user?.userID,
    ad_headlinecopy: headline,
    ad_bodycopy: bodyText,
    cta_buttoncopy: ctaButtonTitle,
    tooltip_location: 'streaks counter',
  };

  useEffect(() => {
    trackEvent(EventNames.TOOLTIP_VIEWED, trackingProperties);
  }, []);

  const handleOnModalClose = (): void => {
    ctaAction();
    trackEvent(EventNames.TOOLTIP_DISMISSED, trackingProperties);
  };

  return (
    <S.ModalContainer className={className}>
      <Modal
        focusSelector={toolTipModalButton}
        ariaLabelledby="tooltip-modal-title"
        onClose={handleOnModalClose}
        colorScheme="light"
        size="small"
      >
        <S.TriangleShape />
        <BodyText
          id="tooltip-modal-title"
          fontFamily="futuraBook"
          textSize="f3"
          css={`
            width: 90%;
            font-weight: bold;
            line-height: 0.75;
            letter-spacing: -0.01em;
          `}
        >
          {headline}
        </BodyText>
        <Spacer spacing="sm3" />
        <BodyText
          dataId="tooltip-modal-description"
          fontFamily="futuraBook"
          textSize="f1"
          textColor="gray1"
          css={`
            letter-spacing: -0.01em;
          `}
        >
          {bodyText}
        </BodyText>
        <Spacer spacing="md1" />
        <Flex width="100%" justify="flex-end">
          <ButtonLink
            href={ctaActionLink}
            target={target}
            dataId="tooltip-modal-button"
            onClick={ctaAction}
            minHeight="1.625rem"
            width="auto"
            css={`
              text-transform: none;
            `}
          >
            {ctaButtonTitle}
          </ButtonLink>
        </Flex>
      </Modal>
    </S.ModalContainer>
  );
};

export default ToolTipModal;
